export default {
    id: "5d1ff79d-47a7-4b5c-bef1-ca84eacceb69",
    icon: "mdi-arrow-right-top",
    name: "shapeArrow90",
    title: "Shape Arrow 90 deg",
    description: "A block arrow 90 degrees",
}